import classNames from 'classnames';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { Component } from 'react';

import StickyComponent from '../StickyComponent';

const propTypes = exact({
  anchors: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeAnchor: PropTypes.string,
});

const defaultProps = {
  activeAnchor: null,
};

class PageAnchors extends Component {
  constructor(props) {
    super(props);

    this.ref = React.createRef();

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      activeAnchor: props.activeAnchor,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeAnchor !== this.props.activeAnchor) {
      this.setState({
        activeAnchor: this.props.activeAnchor,
      });
    }
  }

  handleClick(event, anchor) {
    event.preventDefault();

    this.setState({
      activeAnchor: anchor,
    });

    const anchoredEl = document.querySelector(`#anchor-${anchor}`);
    if (!anchoredEl) return;

    const pos =
      anchoredEl.getBoundingClientRect().top +
      window.pageYOffset -
      this.ref.current.getBoundingClientRect().height;

    window.scrollTo({ top: pos, behavior: 'smooth' });
  }

  render() {
    return (
      <div className="PageAnchors" ref={this.ref}>
        <div className="PageAnchors_content">
          <div className="PageAnchors_body">
            <StickyComponent contained>
              <ul className="PageAnchors_list">
                {this.props.anchors.map((anchor) => (
                  <li key={anchor.href} className="PageAnchors_listItem">
                    <a
                      className={classNames('PageAnchors_link', {
                        active: anchor.href === this.state.activeAnchor,
                      })}
                      href={`#anchor-${anchor.href}`}
                      onClick={(e) => this.handleClick(e, anchor.href)}
                    >
                      {anchor.text}
                    </a>
                  </li>
                ))}
              </ul>
            </StickyComponent>
          </div>
        </div>
      </div>
    );
  }
}

PageAnchors.propTypes = propTypes;
PageAnchors.defaultProps = defaultProps;

export default PageAnchors;
